import React from "react";
import { MessageCircle } from "lucide-react";
import { TRUST } from "../../lib/content";

export const WhatsAppFab = () => {
  const href = `https://wa.me/${TRUST.whatsapp}?text=${encodeURIComponent("Assalamu Alaikum, I would like to connect with Hazrat Sufi Sarkar Trust.")}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-40 grid place-items-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-emerald-deep/40 hover:scale-110 hover:bg-[#1ebe5a] transition-all duration-300"
    >
      <MessageCircle size={26} />
      <span className="absolute inset-0 rounded-full animate-ping bg-[#25D366]/30" aria-hidden />
    </a>
  );
};

export default WhatsAppFab;
